import React from 'react';
import { timeAgo } from '@/utils/ts/stringUtils';

import AvatarComponent from '../AvatarComponent/AvatarComponent';

interface Props {
  notification: any;
  handleNavigate: () => void;
}

const ShipmentNotification: React.FC<Props> = ({ notification, handleNavigate }) => {
  return (
    <div className={`single-notification cursor-pointer ${notification.seen && 'seen'}`} onClick={handleNavigate}>
      <div className="unread-dot"></div>
      <div className="avatar-div">
        <AvatarComponent
          src={notification?.influencerId?.profile_pic}
          alt={notification?.influencerId?.name || notification?.influencerId?.user_name}
        />
      </div>
      <div className="text-div">
        <h3 className="title font-normal">{notification?.content?.body}</h3>

        <p className="timestamp">{timeAgo(notification?.createdAt)}</p>
      </div>
    </div>
  );
};

export default ShipmentNotification;
